"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const classnames_1 = __importDefault(require("classnames"));
const SimpleCheckbox_1 = __importDefault(require("./SimpleCheckbox"));
const FormOptions_1 = __importDefault(require("../styles/FormOptions"));
exports.default = (0, mobx_react_1.observer)(({ form }) => (react_1.default.createElement("form", { onSubmit: form.onSubmit },
    react_1.default.createElement("h4", { className: (0, classnames_1.default)(FormOptions_1.default.h4) }, "FORM OPTIONS"),
    form.map(field => react_1.default.createElement(SimpleCheckbox_1.default, { field: field, key: field.key })))));
